import React, { useState, useEffect } from "react";

import {
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    ListItemIcon,
    Button,
    Typography,
    TextField,
} from "@material-ui/core";
import {
    Modal,
    ModalFooter,
    ModalBody,
    ModalHeader,
    Col,
    Row,
    Label,
} from "reactstrap";

import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

import styled from "styled-components";
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
export default (props) => {
    const [points, setPoints] = useState(props.points);
    const [newPoint, setNewPoint] = useState("");
    const [modalData, setModalData] = useState(false);
    const [modalInput, setModalInput] = useState(false);
    useEffect(() => {
        setPoints(props.points);
    }, [props.points]);
    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Talking Points
            </Typography>
            <List style={{ height: "50vh", overflowY: "scroll" }}>
                {points &&
                    points.map((e, i) => {
                        return (
                            <ListItem
                                style={{
                                    border: "1px solid lightgray",
                                    padding: 6,
                                    marginBottom: 6,
                                    borderRadius: 12,
                                }}
                            >
                                <ListItemIcon>
                                    <Typography align="center">
                                        {i + 1}
                                    </Typography>
                                </ListItemIcon>

                                <ListItemText
                                    primary={e}
                                    style={{ maxWidth: "80%" }}
                                />
                                {props.pageType !== "view" && (
                                    <ListItemSecondaryAction>
                                        <div
                                            style={{
                                                paddingLeft: 24,
                                                minWidth: 100,
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => {
                                                    setModalInput(e);
                                                    setModalData(i);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>{" "}
                                            <IconButton
                                                onClick={() => {
                                                    let p = points;
                                                    p.splice(i, 1);
                                                    props.setData(p);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </ListItemSecondaryAction>
                                )}
                            </ListItem>
                        );
                    })}
            </List>
            {props.pageType !== "view" && (
                <TextField
                    rows={4}
                    rowsMax={4}
                    multiline
                    style={{
                        border: "1px solid lightgray",
                        padding: 4,
                        marginTop: 12,
                        marginBottom: 12,
                    }}
                    fullWidth
                    value={newPoint}
                    onChange={(event) => {
                        setNewPoint(event.target.value);
                    }}
                />
            )}
            {props.pageType !== "view" && (
                <Button
                    disabled={newPoint === ""}
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                        let p = points;
                        p.push(newPoint);
                        props.setData(p);
                        setNewPoint("");
                    }}
                    style={{
                        margin: "inherit",
                        background: "#0188cc",
                        color: "white",
                    }}
                >
                    Submit Point
                </Button>
            )}

            <Modal isOpen={modalData !== false}>
                <ModalHeader>
                    <Typography variant="headline">Edit Point</Typography>
                </ModalHeader>

                <ModalBody>
                    <ModalRow>
                        <Col>
                            <Label for="name">Point&nbsp;:&nbsp;&nbsp;</Label>
                            {modalInput && (
                                <TextField
                                    multiline
                                    style={{
                                        border: "2px solid #0188cc",
                                        borderRadius: "9px",
                                        marginBottom: "11px",
                                        width: "100%",
                                    }}
                                    value={modalInput}
                                    onChange={(event) => {
                                        setModalInput(event.target.value);
                                    }}
                                />
                            )}
                        </Col>
                    </ModalRow>
                </ModalBody>

                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                setModalData(false);
                                setModalInput("");
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{
                                backgroundColor: "red",
                                color: "white",
                            }}
                            onClick={() => {
                                let p = points;
                                p[modalData] = modalInput;
                                props.setData(p);
                                setModalData(false);
                                setModalInput("");
                            }}
                        >
                            Update
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </Grid>
    );
};
